import { PropsWithChildren } from "react";

import {
  Drawer,
  DrawerContent,
  DrawerOverlay,
  DrawerCloseButton,
  DrawerContentProps,
} from "@chakra-ui/react";

import { Drawer as DrawerType } from "@/providerFactories/createDrawerProvider";

function SidebarDrawer({
  children,
  size = "sm",
  isOpen,
  onClose,
  ...props
}: PropsWithChildren<
  { size?: "xs" | "sm" | "md" | "lg" | "xl" | "full" } & DrawerType & DrawerContentProps
>) {
  return (
    <Drawer preserveScrollBarGap isOpen={isOpen} placement="left" size={size} onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent {...props}>
        <DrawerCloseButton />
        {children}
      </DrawerContent>
    </Drawer>
  );
}

export default SidebarDrawer;
